import React, {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
    FlexiCancelButton,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCodePipeline} from '../hooks/useCodePipeline.ts';
import {useCodePipelinesSelection} from '../hooks/useCodePipelinesSelection.ts';
import {ImportSingleRecordButton} from '../buttons/ImportSingleRecordButton.tsx';
import {useVerifiedPermissions} from '../../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../../config/rbac/actions.ts';


export const EditPage = () => {

    const {name: pipelineName} = useParams();

    if (typeof pipelineName === 'undefined') {
        throw new Error('pipelineName is required parameter');
    }

    const decodedName = decodeURIComponent(pipelineName);

    const navigate = useNavigate();

    const {
        record: pipeline,
    } = useCodePipeline(decodedName);

    const {handleClearSelection} = useCodePipelinesSelection();
    const {allowedActions} = useVerifiedPermissions();

    const tools = [] as React.ReactElement[];

    if (allowedActions.includes(rbacActions.ImportCodePipeline)) {
        tools.push(<ImportSingleRecordButton key={'import'} name={decodedName}/>);
    }

    tools.push(
        <FlexiCancelButton key={'close'}
                           onClick={() => navigate(`/code-pipelines`)}/>
    );

    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!pipeline) {
        return <PlatformLoader message='Loading code pipeline...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={pipeline.name}
            pageNavigation={<EditPageNavigation component={pipeline}/>}
            tools={tools}
        >
            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 6
                }}>
                    <Profile record={pipeline}/>
                </Grid.Col>
            </Grid>
        </FormPageLayout>
    );
};
